import * as THREE from 'three';
import {circle} from './circle';

export class triangle {
    public p1: THREE.Vector2;
    public p2: THREE.Vector2;
    public p3: THREE.Vector2;

    constructor (p1: THREE.Vector2, p2: THREE.Vector2, p3: THREE.Vector2) {
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
    }

    // 三角形の重心
    public centerOfGravity()
    {
        let x = (this.p1.x + this.p2.x + this.p3.x) / 3;
        let y = (this.p1.y + this.p2.y + this.p3.y) / 3;
        return new THREE.Vector2(x, y);
    }
    
    //ヘロンの公式より面積を求める
    public size() {
        const a = this.p1.distanceTo(this.p2);
        const b = this.p1.distanceTo(this.p3);
        const c = this.p2.distanceTo(this.p3);

        const s = (a + b + c) / 2;
        return Math.sqrt(s*(s-a)*(s-b)*(s-c));
    }

    //内接円
    public incircle() {
        const size = this.size();
        const p1 = this.p1;
        const p2 = this.p2;
        const p3 = this.p3;

        //内接円の半径を求める公式　r = 2S / (a+b+c)
        const r = 2 * size / (p1.distanceTo(p2) + p1.distanceTo(p3) + p2.distanceTo(p3));

        // P1を原点とした座標（ベクトル）を求め正規化
        const a = p2.clone().sub(p1).normalize();
        const b = p3.clone().sub(p1).normalize();

        // Aの単位ベクトルとBの単位ベクトルから角度を2等分するベクトルMを求め正規化
        const m = a.clone().add(b).normalize();

        // ベクトルAとベクトルMからcosθを求める。
        const cos = a.dot(m);

        // const cos = (a.x * m.x + a.y * m.y) / (Math.sqrt(a.x ** 2 + a.y ** 2) * Math.sqrt(m.x ** 2 + m.y ** 2));
        console.log(`cosθ: ${cos} - ${b.dot(m)}`);

        // ５／６．半径とcosθから隣辺の長さを求める。
        const sin = Math.sqrt(1 - cos ** 2);    // sinθを求める
        const tan = sin / cos;                  // tanθを求める
        const s = r / tan;
        console.log('隣辺: ' + s);

        // ７．単位ベクトルと隣辺の長さから接点の座標を求める。
        const ca = a.clone().multiplyScalar(s);
        const cb = b.clone().multiplyScalar(s);
        // const xCA = xUA * s;
        // const yCA = yUA * s;
        // const xCB = xUB * s;
        // const yCB = yUB * s;

        // 制御点をPとした二次ベジェを描画してみる。
        // if (quadraticCurveTo.checked) {
        //     ctx.beginPath();
        //     ctx.strokeStyle = 'green';
        //     ctx.moveTo(xCA, yCA);
        //     ctx.quadraticCurveTo(0, 0, xCB, yCB);
        //     ctx.stroke();
        // }

        // 円の中心 : 円の中心ベクトルはベクトルMの単位ベクトルに対辺の長さを掛けたものになる。
        const e = m.clone().multiplyScalar(r / sin);

        // context2d.drawLine(new THREE.Vector2(p1.x, p1.y), new THREE.Vector2(p2.x, p2.y), "green");
        // context2d.drawLine(new THREE.Vector2(p2.x, p2.y), new THREE.Vector2(p3.x, p3.y), "green");
        // context2d.drawLine(new THREE.Vector2(p3.x, p3.y), new THREE.Vector2(p1.x, p1.y), "green");

        return new circle(new THREE.Vector2(p1.x + e.x, p1.y + e.y), r);
        // context2d.drawCircle(p1.x + e.x, p1.y + e.y, r, 'black');

        // // ９．A接点の角度を求める。
        // const thetaCA = Math.atan2(yCA - yE, xCA - xE);

        // // ９．B接点の角度を求める。
        // const thetaCB = Math.atan2(yCB - yE, xCB - xE);


    }
}
